import { Metamodel } from 'app/model/base/model';
import { FormatWriteSettings } from './format-write-settings';
import { IModel, IAttribute } from 'app/model/base/annotation';

import { JsonDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.json.formatWrite,
    tags: { datasetModel: Metamodel.modelFor(JsonDataset) }
})
export class JsonFormatWriteSettings extends FormatWriteSettings {
    public static readonly MODEL: IModel;
    public static readonly PATTERN: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PATTERN',
        display: stringResources.Dataflow_DatasetFileNameOptionPatternLabel
    })
    public filePattern?: string;
}
